// schema.org Product data, kept free of React so the build script
// (scripts/page-html.js) can write it into each product page's HTML as well.
const SITE = "https://technogeniousja.com";
const SELLER = { "@type": "Organization", "@id": `${SITE}/#business`, name: "Technogenious Solutions" };

const positivePrice = (n: unknown): n is number => typeof n === "number" && Number.isFinite(n) && n > 0;
const stockCount = (n: unknown) => (Number.isSafeInteger(n) ? Math.max(0, n as number) : 0);
const availability = (inStock: boolean) => `https://schema.org/${inStock ? "InStock" : "OutOfStock"}`;

/**
 * schema.org Product data for a store product. Offers are only included for
 * prices the shop treats as confirmed, mirroring the buy-button rules on the
 * product page, so search results never show a price the store won't honour.
 */
export function productJsonLd(item: any, description: string, image: string[]) {
  const url = `${SITE}/product/${item._id}`;
  const data: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Product",
    name: item.name,
    description,
    url,
    ...(image.length ? { image } : {}),
  };
  if (Array.isArray(item.option) && item.option.length > 0) {
    const confirmed = item.option.filter(
      (o: any) => o && o.priceConfirmed && positivePrice(o.price) && Number.isSafeInteger(o.quantity) && o.quantity >= 0
    );
    if (confirmed.length) {
      const prices = confirmed.map((o: any) => o.price);
      data.offers = {
        "@type": "AggregateOffer",
        priceCurrency: "USD",
        lowPrice: Math.min(...prices).toFixed(2),
        highPrice: Math.max(...prices).toFixed(2),
        offerCount: confirmed.length,
        availability: availability(confirmed.some((o: any) => o.quantity > 0)),
        url,
        seller: SELLER,
      };
    }
  } else if (!item.tags?.includes("catalog-review") && positivePrice(item.price)) {
    data.offers = {
      "@type": "Offer",
      priceCurrency: "USD",
      price: item.price.toFixed(2),
      availability: availability(stockCount(item.totalQantity) > 0),
      itemCondition: "https://schema.org/NewCondition",
      url,
      seller: SELLER,
    };
  }
  return data;
}
